import Image from 'next/legacy/image';

import { H1, H2 } from '@common/headline';

import Blob1 from '@public/img/recipes-and-guides/blob-1.svg';
import Blob2 from '@public/img/recipes-and-guides/blob-2.svg';

export const RecipesAndGuidesHeader = (): JSX.Element => (
  <div className="relative flex min-h-[371px] bg-purple px-3 pb-[100px] pt-[176px] text-center text-blue lg:px-[60px] lg:pb-[185px] lg:pt-[261px]">
    <div className="z-10 w-[100%]">
      <div className="lg:hidden">
        <H1>
          Recipes <span className="text-mono-white">and</span> Guides
        </H1>
      </div>
      <div className="hidden lg:block">
        <H2>
          Recipes <span className="text-mono-white">and</span> Guides
        </H2>
      </div>
    </div>
    <div className="lg:block">
      <Image
        src={Blob1}
        layout="fill"
        objectFit="scale-down"
        objectPosition="left bottom"
        alt="Blob 1"
      />
    </div>
    <div className="hidden lg:block">
      <Image
        src={Blob2}
        layout="fill"
        objectFit="scale-down"
        objectPosition="right top"
        alt="Blob 2"
      />
    </div>
  </div>
);
